import React, { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import Layout from '../layout/Layout'
import NotFound from 'components/auth/NotFound'

const Auth = lazy(() => import('../components/auth/AuthLayout'))
const Landing = lazy(() => import('../components/landing/Landing'))

function LandingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Auth />} />
        <Route path="home" element={<Landing />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default LandingRoutes
